import { Inject, Injectable } from '@angular/core';
import {
  TENANT_PRIVACY_POLICY_URL,
  TENANT_PRIVACY_STATEMENT_URL,
  TENANT_TNCS_URL,
} from '@rd/core/tokens/rd-lib.token';
import { NavLink } from '@rd/types';
import { StartsWithHttps } from 'global-types';

@Injectable({
  providedIn: 'root',
})
export class StarNavLinksService {
  constructor(
    @Inject(TENANT_TNCS_URL)
    private tenantTncsUrl: StartsWithHttps,
    @Inject(TENANT_PRIVACY_POLICY_URL)
    private tenantPrivacyPolicyUrl: StartsWithHttps,
    @Inject(TENANT_PRIVACY_STATEMENT_URL)
    private tenantPrivacyStatementUrl: StartsWithHttps,
  ) {}

  faqsLink = 'https://www.staralliance.com/en/web/rewards/au/faqs';
  contactUsFormLink =
    'https://www.staralliance.com/en/web/rewards/au/contact-form';
  cookiePolicylink =
    'https://www.staralliance.com/en/web/rewards/au/cookie-policy';

  nonLoggedInLinks: NavLink[] = [
    {
      translationKey: 'wl.star.header.use_points',
      route: '/transfer/programs',
    },
    {
      translationKey: 'wl.star.footer.faqs',
      route: this.faqsLink,
    },
    {
      translationKey: 'wl.star.footer.terms_of_use',
      route: this.tenantTncsUrl,
    },
    {
      translationKey: 'wl.star.footer.privacy_policy',
      route: this.tenantPrivacyPolicyUrl,
    },
    {
      translationKey: 'wl.star.footer.privacy_statement',
      route: this.tenantPrivacyStatementUrl,
    },
    {
      translationKey: 'wl.star.footer.contact_us',
      route: this.contactUsFormLink,
    },
    {
      translationKey: 'wl.star.footer.cookie',
      route: this.cookiePolicylink,
    },
  ];
}
